export const buttonText = (status: string) => {
  if (status === "paid" || status === "voided") {
    return "View";
  } else {
    return "Pay";
  }
};

export const invoiceStatus = (status: string, dueDate: Date | null) => {
  if (!dueDate) {
    return status.toUpperCase();
  } else {
    if (status === "pending") {
      const due = new Date(dueDate);
      if (due < new Date()) {
        return "PAST DUE";
      } else {
        return "PENDING";
      }
    } else {
      return status.toUpperCase();
    }
  }
};

export const invoiceStatusStyle = (status: string, dueDate: Date | null) => {
  if (status === "pending") {
    if (!dueDate) {
      return "bg-red-100 text-red-800";
    } else {
      const due = new Date(dueDate);
      if (due < new Date()) {
        return "bg-red-100 text-red-800";
      } else {
        return "bg-yellow-100 text-yellow-800";
      }
    }
  } else if (status === "paid") {
    return "bg-green-100 text-green-800";
  } else if (status === "voided") {
    return "bg-gray-200 text-gray-800";
  }
};
